export const gatewayConfig = {
  SYSTEMS_SERVICE,
  GEO_SERVICE,
  DETECTION_SERVICE,
  MAIL_SERVICE,
  USER_SERVICE,
  CAMPAIGN_SERVICE,
  NEGOTIATION_SERVICE,
  SHARE_SERVICE,
  TOKEN_SERVICE,
  ORDER_SERVICE,
  PLANNING_SERVICE,
  ADVERTISER_SERVICE,
  SCHEDULER_SERVICE,
  HISTORY_SERVICE,
  CDN_SERVICE,
  QUOTE_SERVICE,
  OTP_SERVICE,
  LICENSES_SERVICE,
  SEARCH_SERVICE,
}

function GEO_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale"
      apiVer = "v1";
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function DETECTION_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale/"
      apiVer = "v1";
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale/"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale/"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function HISTORY_SERVICE(ambience) {
  let apiUrl, apiVer, serviceName;
  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale"
      apiVer = "v1";
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer,
    serviceName
  }
}

function MAIL_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale"
      apiVer = "v1";
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function SYSTEMS_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale/"
      apiVer = "v2";
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale/"
      apiVer = "v2";
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale/"
      apiVer = "v2";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function SEARCH_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale/"
      apiVer = "v1";
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale/"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale/"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function CAMPAIGN_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale/"
      apiVer = "v1";
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale/"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale/"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function PLANNING_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale/"
      apiVer = "v2";
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale/"
      apiVer = "v2";
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale/"
      apiVer = "v2";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function USER_SERVICE(ambience) {
  let apiUrl
  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it"
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it"
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
  }
}

function ORDER_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale/";
      apiVer = "v1";
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale/"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale/"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function NEGOTIATION_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale/";
      apiVer = "v1"
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale/"
      apiVer = "v1"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}
function ADVERTISER_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale/v1/";
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale/v1/"
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale/v1/"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function SHARE_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale/"
      apiVer = "v1"
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale/"
      apiVer = "v1"
      break;
    default:
  }

  return { apiUrl, apiVer }
}

function TOKEN_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale/"
      apiVer = "v1"
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale/"
      apiVer = "v1"
      break;
    default:
  }

  return { apiUrl, apiVer }
}

function SCHEDULER_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale/"
      apiVer = "v1"
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale/"
      apiVer = "v1"
      break;
    default:
  }

  return {
    apiUrl,
    apiVer
  }
}

function CDN_SERVICE(ambience) {
  let CDNUrl

  switch (ambience) {
    case "dev":
      CDNUrl = "https://cdn.codesour.dev/codesour"
      break;
    case "test":
      CDNUrl = "https://cdn.codesour.dev/codesour"
      break;
    case "prod":
      CDNUrl = "https://cdn.codesour.dev/codesour"
      break;
    default:
  }

  return {
    CDNUrl,
  }
}

function QUOTE_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale/";
      apiVer = "v1"
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/ale/"
      apiVer = "v1"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function OTP_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/";
      apiVer = "v1"
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/"
      apiVer = "v1"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function LICENSES_SERVICE(ambience) {
  let apiUrl, apiVer = "v2";

  switch (ambience) {
    case "dev":
      apiUrl = "https://dev-api.gravityplatform.it/ale/";
      break;
    case "test":
      apiUrl = "https://test-api.gravityplatform.it/ale/";
      break;
    case "prod":
      apiUrl = "https://api.gravityplatform.it/v2/licenses/ale/";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}